import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import styles from "../../Header.css";
import { getPathFromAbsoluteUrl } from "../../../../services/service-utils";
import { LIB } from "../../../../constants/consts-types";
import Svg from "../../../Svg/Svg";

export function LogoLink({ isThy, homeUrl, setActiveMenuIndex, colorsHeader }) {
  return (
    <Link
      to={getPathFromAbsoluteUrl(homeUrl)}
      title={LIB.link_home_label}
      aria-label={LIB.link_home_label}
      className={[
        styles.Logo,
        isThy && styles["Logo_thy"],
        styles["Header-Logo"],
      ].join(" ")}
      onClick={() => {
        setActiveMenuIndex(undefined);
      }}
    >
      <Fragment>
        <div
          className={[
            styles["Logo-ImageWrapper"],
            styles["Logo-ImageWrapper_simple"],
            isThy && styles["Logo-ImageWrapper_thy"],
          ].join(" ")}
        >
          {isThy ? (
            // <Svg
            //   id="logo-thy"
            //   className={styles["logo-thy"]}
            //   style={colorsHeader}
            // />
            <svg
              className={[styles["LogoImage"], styles["LogoImage_thy"]].join(
                " "
              )}
            >
              <use
                xmlnsXlink="http://www.w3.org/1999/xlink"
                xlinkHref={`#svg-logo-thy-detailed`}
              />
            </svg>
          ) : (
            // <Svg
            //   id={isGuide ? Icon.LOGO_GUIDE : Icon.LOGO}
            //   className={styles.logo}
            //   style={colorsHeader}
            // />
            <svg className={styles["LogoImage"]}>
              <use
                xmlnsXlink="http://www.w3.org/1999/xlink"
                xlinkHref={`#svg-logo-detailed`}
              />
            </svg>
          )}
        </div>
        <div
          className={[
            styles["Logo-ImageWrapper"],
            styles["Logo-ImageWrapper_detailed"],
            isThy && styles["Logo-ImageWrapper_thy"],
            isThy && styles["Logo-ImageWrapper_detailed_thy"],
          ].join(" ")}
        >
          {isThy ? (
            <svg
              className={[styles["LogoImage"], styles["LogoImage_thy"]].join(
                " "
              )}
            >
              <use
                xmlnsXlink="http://www.w3.org/1999/xlink"
                xlinkHref={`#svg-logo-thy-detailed`}
              />
            </svg>
          ) : (
            <svg className={styles.LogoImage}>
              <use
                xmlnsXlink="http://www.w3.org/1999/xlink"
                xlinkHref={`#svg-logo-detailed`}
              />
            </svg>
          )}
        </div>
      </Fragment>
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header/Components/LogoLink/LogoLink.js